import { observer } from "mobx-react-lite";
import React from "react";
import { uploadSteps } from "../../../helpers/renderViewHelper";
import { useMst } from "../../../store/root";
import styles from "./LoadingBar.module.scss";

type Props = {
  id: number;
};
const RENDER_WEIGHT = 30;
const UPLOAD_WEIGHT = 100 - RENDER_WEIGHT;

export const LoadingBar = observer(({ id }: Props) => {
  const {
    renderStore: {
      renderedAssetsTypes,
      passedRenderSteps,
      currentStepProgress,
    },
    uiStore: { renderProgress, setRenderProcessHidden, renderProcessVisible },
    compositionStore: {
      compositionCurrentlyRendering,

      allRenderedCompositions,
    },
  } = useMst();

  const uploadStepsFinal = [
    ...uploadSteps.filter((item) => renderedAssetsTypes.includes(item)),
  ];

  // Calculates the progress of the loading bar
  const progress = (() => {
    if (allRenderedCompositions.some((comp) => comp === id)) return 100;
    if (compositionCurrentlyRendering.id !== id) return 0;

    const renderPercentage = renderProgress * RENDER_WEIGHT; // First 30%

    const uploadPercentage =
      ((passedRenderSteps.length + currentStepProgress) /
        (uploadStepsFinal.length || 1)) *
      UPLOAD_WEIGHT; // Second 70%

    // Handles edge case where passedRenderStep has not been updated
    return renderPercentage === RENDER_WEIGHT
      ? renderPercentage + uploadPercentage
      : renderPercentage;
  })();

  return (
    <div className={styles.LoadingBar}>
      <div
        className={styles.FillerStyle}
        style={{ width: `${progress <= 100 ? progress : 100}%` }}
      ></div>
    </div>
  );
});
